var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    attrs: {
      "lass": "form-horizontal",
      "data-vv-scope": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('legend', [_vm._v("Create Group")]), _vm._v(" "), _c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("City"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('city')
    },
    attrs: {
      "options": _vm.cityList,
      "selected-option": _vm.cityObjData,
      "name": "city",
      "placeholder": "Select City"
    },
    on: {
      "select": _vm.selectedCity
    },
    model: {
      value: (_vm.cityid),
      callback: function($$v) {
        _vm.cityid = $$v
      },
      expression: "cityid"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form.city')),
      expression: "errors.has('form.city')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The City field is required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Group Type"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-group'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('groupType')
    },
    attrs: {
      "options": _vm.groupTypeList,
      "selected-option": _vm.groupTypeObjData,
      "name": "groupType",
      "placeholder": "Select Group Type"
    },
    on: {
      "select": _vm.selectedGroupType
    },
    model: {
      value: (_vm.groupType),
      callback: function($$v) {
        _vm.groupType = $$v
      },
      expression: "groupType"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form.groupType')),
      expression: "errors.has('form.groupType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form.groupType')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Mode"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-automobile'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('routeMode')
    },
    attrs: {
      "options": _vm.modeList,
      "selected-option": _vm.modeObjData,
      "name": "routeMode",
      "placeholder": "Select Group Type"
    },
    on: {
      "select": _vm.selectedRouteMode
    },
    model: {
      value: (_vm.routeMode),
      callback: function($$v) {
        _vm.routeMode = $$v
      },
      expression: "routeMode"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form.routeMode')),
      expression: "errors.has('form.routeMode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form.routeMode')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Group Name ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-users'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "name": "groupName",
      "readonly": "",
      "placeholder": "Enter Group Name",
      "id": "groupName"
    },
    model: {
      value: (_vm.groupName),
      callback: function($$v) {
        _vm.groupName = $$v
      },
      expression: "groupName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Group Number")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-users'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.groupNumber),
      expression: "groupNumber"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('groupNumber')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Group Number",
      "name": "groupNumber",
      "id": "groupNumber",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.groupNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.groupNumber = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Search")]), _vm._v(" \n                      "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v(" Reset")])])], 1)], 1)])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('div', {
    staticClass: "card-body col-md-12",
    staticStyle: {
      "margin-bottom": "0rem",
      "padding": "0px",
      "background-color": "white"
    }
  }, [_c('legend', {
    staticStyle: {
      "background-color": "#c2cfd6"
    }
  }, [_vm._v("Total Destination Allocated To Group: " + _vm._s(_vm.totalmappedhubs) + "\n            "), (_vm.connectionDestList.length > 0) ? _c('b-input-group', {
    staticStyle: {
      "margin": "-26px 0px -3px 68%",
      "width": "30%"
    },
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('model-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.listHubZoneData,
      "name": "hubzoneid",
      "placeholder": "Select Zone"
    },
    on: {
      "input": function($event) {
        return _vm.SelectZone()
      }
    },
    model: {
      value: (_vm.hubzoneid),
      callback: function($$v) {
        _vm.hubzoneid = $$v
      },
      expression: "hubzoneid"
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('fieldset', [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.connDestLoading
    },
    on: {
      "update:active": function($event) {
        _vm.connDestLoading = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitHub('hubsave')
      }
    }
  }, [_c('div', {
    class: ("" + ((_vm.connectionDestList.length>0) ? 'showdest' : '')),
    staticStyle: {
      "overflow-x": "auto",
      "margin-top": "1%"
    }
  }, [_c('table', {
    staticClass: "table-hover datatables tbl",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-left tableheader",
    attrs: {
      "colspan": "4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkAllHub),
      expression: "checkAllHub"
    }],
    staticStyle: {
      "cursor": "pointer",
      "margin-left": "0.5%"
    },
    attrs: {
      "type": "checkbox",
      "id": "all"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkAllHub) ? _vm._i(_vm.checkAllHub, null) > -1 : (_vm.checkAllHub)
    },
    on: {
      "click": _vm.checkHub,
      "change": function($event) {
        var $$a = _vm.checkAllHub,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkAllHub = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkAllHub = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkAllHub = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "for": "all"
    }
  }, [_vm._v(" Select All")])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.connectionDestList), function(destination) {
    return _c('tr', _vm._l((destination), function(hub, index) {
      return _c('td', [_c('input', {
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "type": "checkbox",
          "disabled": hub.isHubDisabled,
          "id": hub.hubId
        },
        domProps: {
          "checked": _vm.checked[hub.hubId]
        },
        on: {
          "change": _vm.updateCheckDest
        }
      }), _vm._v(" "), _c('label', {
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "for": hub.hubId
        }
      }, [_vm._v(" " + _vm._s(hub.hubName) + " (" + _vm._s(hub.hubId) + ")")])])
    }), 0)
  }), _vm._v(" "), (_vm.connectionDestList.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer",
    staticStyle: {
      "padding": "0.25rem"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.clickedMB),
      expression: "clickedMB"
    }],
    staticClass: "common-success",
    staticStyle: {
      "margin-left": "90%"
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])])])], 1)], 1)])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.addmodalShow = false
      }
    },
    model: {
      value: (_vm.addmodalShow),
      callback: function($$v) {
        _vm.addmodalShow = $$v
      },
      expression: "addmodalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v("Do you want to create group and allocate locations?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": [_vm.takeAction, function($event) {
        _vm.addmodalShow = false
      }]
    }
  }, [_vm._v("Save changes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeStatusModal
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Group List")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: "fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }, [_vm._v(" Filter")]), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  })]), _c('br'), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitSearch.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("City "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('form-1.city')
    },
    attrs: {
      "options": _vm.cityList,
      "selected-option": _vm.citySearchObjData,
      "name": "city",
      "placeholder": "Select City"
    },
    on: {
      "select": _vm.selectedCitySearch
    },
    model: {
      value: (_vm.citySearch),
      callback: function($$v) {
        _vm.citySearch = $$v
      },
      expression: "citySearch"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.city')),
      expression: "errors.has('form-1.city')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-1.city')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('b-form-checkbox', {
    staticStyle: {
      "font-weight": "100",
      "margin-top": "15px"
    },
    attrs: {
      "name": "citySearchStatus"
    },
    model: {
      value: (_vm.citySearchStatus),
      callback: function($$v) {
        _vm.citySearchStatus = $$v
      },
      expression: "citySearchStatus"
    }
  }, [_vm._v(" IsActive")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.getGroupTemplates
    }
  }, [_vm._v("Search")]), _vm._v(" \n                    ")])], 1)], 1)])])])])], 1), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Group Number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Group Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("City ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Routemode ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [(_vm.resultCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "7",
      "align": "center"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.templateList), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.groupno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.groupname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.citySearchName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.routemode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.isactive == true) ? _c('span', {
      staticClass: "badge badge-success",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.getStatusRowData(data)
        }
      }
    }, [_vm._v("Active")]) : _vm._e(), _vm._v(" "), (data.isactive == false) ? _c('span', {
      staticClass: "badge badge-danger",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.getStatusRowData(data)
        }
      }
    }, [_vm._v("Inactive")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-eye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#ff0000"
      },
      attrs: {
        "title": "View Mapped Hubs"
      },
      on: {
        "click": function($event) {
          return _vm.getHubMappedListData(data)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-university fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#6bd5e1"
      },
      attrs: {
        "title": "Allocate Hubs"
      },
      on: {
        "click": function($event) {
          return _vm.openHubMapModal(data)
        }
      }
    })])])
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalRows > 10),
      expression: "totalRows>10"
    }],
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.groupStatusModal = false
      }
    },
    model: {
      value: (_vm.groupStatusModal),
      callback: function($$v) {
        _vm.groupStatusModal = $$v
      },
      expression: "groupStatusModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusGroupModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(" Do you want to " + _vm._s(_vm.changestatus) + " this Group Template?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": [_vm.changeGroupTemplateStatus, function($event) {
        _vm.groupStatusModal = false
      }]
    }
  }, [_vm._v("Save changes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeStatusGroupModal
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "modal-lg"
    },
    on: {
      "ok": function($event) {
        _vm.allocateHubmodal = false
      }
    },
    model: {
      value: (_vm.allocateHubmodal),
      callback: function($$v) {
        _vm.allocateHubmodal = $$v
      },
      expression: "allocateHubmodal"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Allocate Hubs")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeMapHubWithGroup
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v("Hub List")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    attrs: {
      "options": _vm.fetchedHubs,
      "selected-option": _vm.hubListObjData,
      "name": "selectedHub",
      "id": "selectedHub",
      "placeholder": "Select Hub"
    },
    on: {
      "select": _vm.selectedHubName
    },
    model: {
      value: (_vm.selectedHub),
      callback: function($$v) {
        _vm.selectedHub = $$v
      },
      expression: "selectedHub"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "rolefooter form-actions"
  }, [_c('b-button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveMapHubWithGroup
    }
  }, [_vm._v("Map Hub")]), _vm._v(" "), _c('b-button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeMapHubWithGroup
    }
  }, [_vm._v("Cancel")])], 1)])])], 1)])]), _vm._v(" "), (_vm.showHubListModal == true) ? _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Hubs List"
    },
    model: {
      value: (_vm.showHubListModal),
      callback: function($$v) {
        _vm.showHubListModal = $$v
      },
      expression: "showHubListModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Mapped Hubs")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeshowHubListModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status ")])])]), _vm._v(" "), _c('tbody', [(_vm.mappedHubCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3",
      "align": "center"
    }
  }, [_vm._v("No Hub Mapped")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.mappedHUbsList), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.isactive == true) ? _c('span', {
      staticClass: "badge badge-success",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.getStatusHublistData(data)
        }
      }
    }, [_vm._v("Active")]) : _vm._e(), _vm._v(" "), (data.isactive == false) ? _c('span', {
      staticClass: "badge badge-danger",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.getStatusHublistData(data)
        }
      }
    }, [_vm._v("Inactive")]) : _vm._e()])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeshowHubListModal
    }
  }, [_vm._v("Close")])])])])]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.hubStatusModal = false
      }
    },
    model: {
      value: (_vm.hubStatusModal),
      callback: function($$v) {
        _vm.hubStatusModal = $$v
      },
      expression: "hubStatusModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusHubModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(" Do you want to " + _vm._s(_vm.changestatusHub) + " this Hub From Group Id?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": [_vm.changeMappedHubStatus, function($event) {
        _vm.hubStatusModal = false
      }]
    }
  }, [_vm._v("Save changes")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeStatusHubModal
    }
  }, [_vm._v("Cancel")])])])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-250274b9","hasScoped":true}!./src/views/components/group/creategroup_new/creategroup_new.html
// module id = 845
// module chunks = 2